import AuthSection from './auth-section';

export default AuthSection;
